import React, { useState, useEffect, useRef, Fragment } from "react";
import { Dialog, Transition, Menu } from '@headlessui/react'
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/pro-light-svg-icons/faCircleNotch';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { useTranslation } from "react-i18next";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export function ModalFooter(props) {
  const { saving, cancel, save = null, saveName, color, cancelButtonText } = props
  const { t } = useTranslation('common');
  return (
    <div className="tw-mt-5 sm:tw-mt-6 sm:tw-grid sm:tw-grid-flow-row-dense sm:tw-grid-cols-2 sm:tw-gap-3">
        <button type="button" className="cancelbutton" onClick={cancel}>{cancelButtonText ? cancelButtonText : t('buttons.Cancel')}</button>
        <button disabled={saving} type={save ? 'button' : 'submit'} onClick={save ? save : null} className={classNames("actionbutton", color ? color : "tw-bg-blue-500")}>{saving ? <div><FontAwesomeIcon icon={faCircleNotch} spin /></div> : t(saveName)}</button>
    </div>
  )
}

export function LaunchModal(props) {
    const cancelButtonRef = useRef(null)
    const { open, setOpen, title, titleRaw, description, content, contentRaw, icon, iconBg, buttons, modalFooter, maxWidth = false, showCloseButton = false } = props;
    const { t } = useTranslation('common');
    const bgImage = () => {
      let launcher_background_url = window.localStorage.getItem("launcher_background_url");
      let bgimage = 'img/backgrounds/background1.jpg'
      if (launcher_background_url && launcher_background_url !== 'undefined') {
          bgimage = launcher_background_url
      }
      return bgimage;
    }

    return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="tw-relative tw-z-[999999]" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="tw-ease-out tw-duration-300"
            enterFrom="tw-opacity-0"
            enterTo="tw-opacity-100"
            leave="tw-ease-in tw-duration-200"
            leaveFrom="tw-opacity-100"
            leaveTo="tw-opacity-0"
          >
            <div className="tw-fixed tw-inset-0 tw-bg-cover tw-bg-[#000] tw-bg-blend-multiply tw-bg-opacity-50 tw-transition-opacity"  style={{ backgroundImage: "url(" + bgImage() + ")" }} />
          </Transition.Child>
          <div className="tw-fixed tw-inset-0 tw-z-[999999] tw-overflow-y-auto">
            <div className="tw-flex tw-min-h-full tw-items-center tw-justify-center tw-p-4 tw-text-center sm:tw-p-0">
              <Transition.Child
                as={Fragment}
                enter="tw-ease-out tw-duration-300"
                enterFrom="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
                enterTo="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                leave="tw-ease-in tw-duration-200"
                leaveFrom="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                leaveTo="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
              >
                <Dialog.Panel className={"tw-relative tw-transform tw-rounded-2xl tw-w-full tw-bg-[rgba(var(--kasm-navy-rgb),0.7)] tw-border tw-border-solid tw-border-white/20 text-white tw-backdrop-blur-md tw-px-4 tw-pb-4 tw-pt-5 tw-text-left tw-shadow-[0_0_15px_rgba(0,0,0,0.4)] tw-transition-all sm:tw-my-8 sm:tw-w-full sm:tw-p-6" + (maxWidth ? ' ' + maxWidth : ' sm:tw-max-w-lg')}>
                  <div>
                    <div className="tw-flex tw-gap-6 tw-items-center">
                    {icon &&
                    <div className={"tw-flex tw-items-center tw-justify-center tw-rounded-full tw-w-20 tw-h-20 " + (iconBg ||'')}>
                      {icon || ''}
                    </div>}
                    <div className="tw-flex tw-flex-col tw-flex-1">
                    {(title || titleRaw) && (<Dialog.Title as="h4" className="tw-font-semibold tw-leading-6 dark:tw-text-gray-100">
                        {titleRaw || t(title) || ''}
                      </Dialog.Title>)}
                      {(description) && (
                        <p className="tw-text-xs tw-text-[color:rgb(255_255_255_/_70%)] tw-m-0">{description || ''}</p>
                      )}
</div>
                    </div>

                    <div className="tw-mt-3 tw-text-center sm:tw-mt-5 launch-modal">
                      <div className="tw-mt-2">
                        <div className="tw-text-sm tw-dark">
                          {contentRaw || t(content) || ''}
                        </div>
                      </div>
                    </div>
                  </div>
                  {modalFooter && (
                    <React.Fragment>
                    {modalFooter}
                    </React.Fragment>
                  )}
                  {buttons && 
                  <div className="tw-mt-5 sm:tw-mt-6 sm:tw-grid sm:tw-grid-flow-row-dense sm:tw-grid-cols-2 sm:tw-gap-3">
                    {buttons || ''}
                  </div>}
                  {showCloseButton && <button onClick={() => setOpen(false)} className="tw-absolute tw-top-2 tw-right-2 tw-shadow-[0_0_10px_rgba(0,0,0,0.4)] tw-group tw-cursor-pointer tw-flex tw-w-7 tw-h-7 tw-transition-colors tw-rounded-full tw-bg-[var(--kasm-navy)] hover:tw-bg-pink-800 tw-justify-center tw-items-center"><FontAwesomeIcon className="" icon={faTimes} /></button>}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    )
  }
  